import { useState } from "react"

import { useUI } from "providers/UIProvider"

import { getCountryFlag } from "./getCountryFlag"

import { Container, Box, Flex, Text, Image } from "@chakra-ui/react"

import Dropdown from "components/UI/atoms/Dropdown"
import { LANGS } from "types/shared"
import { useNavigate } from "react-router-dom"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { IDropdownItem } from 'components/UI/atoms/Dropdown/DropdownTypes' 

const LanguageSwitcher = () => {
  const { lang, handleLanguageChange, T } = useUI();
  const { isAdmin } = useAppContext();
  const navigate = useNavigate();

  const [dropdownOpened, toggleDropdown] = useState<boolean>(false);

  const languageItems: IDropdownItem[] = [
    {
      label: T("general.languages.ka"),
      value: "ka",
      image: getCountryFlag("ka"),
    },
    {
      label: T("general.languages.en"),
      value: "en",
      image: getCountryFlag("en"),
    },
  ];

  if(isAdmin) {
    languageItems.push({
      label: T("main.languages.settings_title"),
      value: "lang",
      icon: "edit",
      customHandler: () => {
        navigate("/language-settings")
        
      },
    },)
  }

  return (
    <Container margin={0} pos="relative" zIndex={2} width="160px">
      <Box
        pointerEvents={`${dropdownOpened ? "none" : "auto"}`}
        onClick={() => toggleDropdown(true)}
        width="140px"
        height="40px"
        as="button"
        bg="white"
        boxShadow="primary"
        padding="0 10px"
        borderTopRadius="20px"
        borderBottomRadius={`${dropdownOpened ? "0" : "20px"}`}
        fontSize="base"
        cursor="pointer"
      >
        <Flex justifyContent="space-between">
          <Text>{T(`general.languages.${lang}`)}</Text>
          <Box>
            <Image
              src={getCountryFlag(lang)}
              alt="Selected Language Flag"
              w="20px"
            />
          </Box>
        </Flex>
      </Box>
      <Dropdown
        selectable
        opened={dropdownOpened}
        toggleOpened={toggleDropdown}
        items={languageItems}
        selected={lang}
        setSelected={(selectedLang: LANGS) => handleLanguageChange(selectedLang)}
        excludeSelected
      />
    </Container>
  )
}

export default LanguageSwitcher
